import {AfterViewInit, Component, Injector, Input, OnDestroy, OnInit} from '@angular/core';
import {BaseControlValueAccessor} from '../../../../shared/core/base-control-value-accessor';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {SectionState} from '../../../../shared/components/section/section.model';
import {TypeJuridiction} from '../../../../entities/type-juridiction';
import {ParametersService} from '../../../../shared/services/parameters.service';
import {Subscription} from 'rxjs';
import { RadioFieldsetItem } from '../../../radio-fieldset/radio-fieldset-item.interface';

@Component({
    selector: 'jhi-juridiction-section',
    templateUrl: './juridiction-section.component.html',
    styleUrls: ['./juridiction-section.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: JuridictionSectionComponent,
            multi: true
        }
    ]
})
export class JuridictionSectionComponent extends BaseControlValueAccessor implements OnInit, OnDestroy, AfterViewInit {

    juridiction: TypeJuridiction;

    selectedJuridictionCode: string;

    juridictionTexts: RadioFieldsetItem[] = [
        {
            value: 'TA',
            title: 'Tribunal administratif',
            description: 'Les tribunaux administratifs sont les juridictions de droit commun compétentes en première instance. ' +
                'C\'est à eux que le requérant doit d\'abord s\'adresser.'
        },
        {
            value: 'CAA',
            title: 'Cour administrative d\'appel',
            description: 'Les cours administratives d\'appel sont les juridictions compétentes pour statuer en appel, ' +
                'à la demande d\'une personne privée ou d\'une administration, ' +
                'contre un jugement de tribunal administratif. Elles peuvent, à titre exceptionnel, être juges de premier ressort. '
        },
        {
            value: 'CE',
            title: 'Conseil d\'État',
            description: 'Principalement juge de cassation des décisions rendues par les cours administratives d\'appel, ' +
                'les tribunaux administratifs et les juridictions administratives spécialisées, le Conseil d’État est également, ' +
                'à titre exceptionnel, juge d\'appel et juge de premier ressort.'
        }
    ]

   @Input()
    state: SectionState = {index: 1};

    private typeJuridictions: Array<TypeJuridiction>;

    private subscription: Subscription;

    constructor(injector: Injector, private parametersService: ParametersService) {
        super(injector);
    }

    ngOnInit(): void {
        this.loadTypeJuridictions();
        console.log('state', this.state);
    }

    ngAfterViewInit() {
      document.getElementById('logo-link').focus();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        super.ngOnDestroy();
    }

    protected modelValueChanged(value: any): void {
        if (!value) { return this.onSetJuridiction(this.juridictionTexts[0].value) }
        if (typeof value !== 'string') {
            this.juridiction = value;
            this.selectedJuridictionCode = value.code;
        } else {
            this.onSetJuridiction('TA')
        }// TODO: This is a temporary patch, to be fixed @youssef


    }

    onSetJuridiction(code: string) {
        this.onChange(this.typeJuridictions.find(juridiction => juridiction.code === code));
    }

    loadTypeJuridictions() {
        this.subscription = this.parametersService.getParameters()
            .subscribe(
                parameters => (this.typeJuridictions = parameters.juridictions)
            );
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/juridiction/juridiction-section/juridiction-section.component.ts